import React from 'react';
import { ModuleBridge } from '../components';

export const ReportingMigrationProjectPlan = () => {
    return (
        <>
            <div id="backbone_reporting_migration_project_plan_wrapper"></div>
            <ModuleBridge moduleId="reporting_migration_project_plan_module" />
        </>
    );
};
